<template>
  <div class="developers">
    <DevHome />
  </div>
</template>
<script>
import DevHome from "./DevHome";
// import DevDashboard from "./DevDashboard";
export default {
  components: {
    DevHome
    // DevDashboard
  },
  data() {
    return {
      tabIndex: 0
    };
  },
  mounted() {
    //console.log(process.env);
  },
  methods: {}
};
</script>
<style lang="scss">
.developers {
  background: #f7f8fa;
  min-height: 100vh;
  padding: 20px 0;
  box-sizing: border-box;
  .main {
    width: 890px;
    margin-left: 330px;
    .titlt {
      h1 {
        font-size: 24px;
        color: #333333;
        letter-spacing: 0;
        padding: 40px;
      }
    }
    .dev-tabs {
      padding: 0 38px;
      border-bottom: 1px solid #f0f0f0;
      span {
        display: inline-block;
        line-height: 20px;
        padding-bottom: 25px;
        font-size: 16px;
        color: #777777;
        margin-right: 60px;
        position: relative;
        cursor: pointer;
        &.active {
          color: #333333;
          &::after {
            content: "";
            display: inline-block;
            position: absolute;
            bottom: 0;
            left: 50%;
            width: 50px;
            height: 4px;
            transform: translateX(-50%);
            background: #333;
          }
        }
      }
    }
  }
  .dev-home-inline {
    margin-top: 60px;
    h2 {
      font-size: 30px;
      color: #333333;
      letter-spacing: 0;
      line-height: 40px;
      font-weight: bold;
    }
    .des {
      margin-top: 16px;
      p {
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        line-height: 22px;
      }
    }
    h3 {
      font-size: 20px;
      color: #333333;
      letter-spacing: 0;
      line-height: 26px;
      margin-top: 30px;
      font-weight: bold;
    }
    .cam-site {
      background: #f8f8f8;
      padding: 0 20px 0 20px;
      .title {
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        text-align: center;
        line-height: 22px;
        padding: 14px 0;
      }
      .site-list {
        overflow: hidden;
        .site-item {
          float: left;
          width: 140px;
          height: 60px;
          margin-left: 20px;
          margin-bottom: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .standard-model {
      width: 700px;
      height: 190px;
      background: url("../../assets/img/dev/pc_img.png") no-repeat center center;
      .title {
        font-size: 20px;
        color: #333333;
        letter-spacing: 0;
        text-align: center;
        line-height: 26px;
        padding-top: 20px;
      }
      .model-list {
        overflow: hidden;
        padding: 100px 125px 0 125px;
        display: flex;
        .item {
          flex: 1;
          text-align: center;
          float: left;
          font-size: 12px;
          color: #333333;
          letter-spacing: 0;
          text-align: center;
          line-height: 18px;
        }
      }
      &.model2 {
        background: url("../../assets/img/dev/web_img.png") no-repeat center center;
        .model-list {
          padding: 100px 125px 0 125px;
        }
      }
    }
    .info-table {
      table {
        thead {
          td {
            color: #333;
            font-weight: bold;
          }
        }
        td {
          border: 1px solid #ccc;
          padding: 11px 20px;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          line-height: 22px;
        }
      }
    }
    .code {
      padding: 5px;
      border: 1px solid #ddd;
      border-radius: 4px;
      font-size: 12px;
      line-height: 22px;
    }

    .hr {
      border-bottom: 1px solid #d8d8d8;
      padding-top: 70px;
    }
    pre {
      white-space: pre-wrap;
      word-wrap: break-word;
      font-family: "Open Sans";
      color: #666666;
    }
    .command-line {
      white-space: nowrap;
      overflow: hidden;
      span {
        display: block;
        padding: 11px 50px;
        line-height: 22px;
        border: 2px solid #666666;
        float: left;
        font-size: 14px;
        &:first-child {
          color: #ffffff;
          letter-spacing: 0;
          background: #666666;
          font-weight: 700;
        }
        &:last-child {
          color: #3e62e9;
        }
      }
    }
    .pre-txt {
      font-size: 12px;
      color: #666666;
      letter-spacing: 0;
      line-height: 18px;
      padding: 10px;
      background: #f7f8f9;
      border: 1px solid #e1e1e1;
      border-top: none;
      height: 120px;
      border-radius: 0 0 4px 4px;
    }
    .code-list {
      .inp-box {
        border-radius: 4px 4px 0 0;
      }
    }
    ::v-deep .el-col {
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .nav-menu {
    position: fixed;
    width: 310px;
    bottom: 80px;
    padding: 36px 10px 10px 0px;
    overflow-y: auto;
    // transition: all 100ms;
    &:hover {
      &::-webkit-scrollbar {
        width: 5px;
      }
    }
    &::-webkit-scrollbar {
      width: 0px;
      height: 10px;
    }
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }
    &::-webkit-scrollbar-thumb {
      background: #c7c7c7;
      border-radius: 4px;
      min-height: 28px;
    }
    &.on {
      a.t1 {
        span {
          background: #fff;
        }
        &:hover {
          span {
            background: rgba(255, 45, 137, 0.1);
          }
        }
      }
    }
    a {
      margin-right: 10px;
      display: block;
      letter-spacing: 0;
      overflow: hidden;
      &.t1 {
        font-size: 16px;
        color: #333;
        font-family: "OpenSans-Bold";
        line-height: 30px;
        margin-bottom: 6px;
        span {
          padding-left: 30px;
          font-family: "OpenSans-Bold";
        }
        &:first-child {
          margin-bottom: 12px;
        }
        &:hover {
          color: #ff2d89;
          background: rgba(255, 45, 137, 0.1);
          border-radius: 0 100px 100px 0;
        }
      }
      &.t2 {
        font-size: 16px;
        color: #444444;
        letter-spacing: 0;
        line-height: 22px;
        margin-bottom: 10px;
        span {
          padding: 4px 0 4px 30px;
          &.active {
            color: #ff2d89;
            background: #fff;
            &:hover {
              color: #ff2d89;
              font-weight: 500;
            }
          }
        }
        &:hover {
          span {
            font-weight: bold;
            color: #000;
          }
        }
      }
      &.t3 {
        font-size: 14px;
        color: #444444;
        letter-spacing: 0;
        line-height: 22px;
        margin: 6px 0;
        span {
          padding: 4px 0 4px 50px;
          &.active {
            color: #ff2d89;
            background: #fff;
            &:hover {
              color: #ff2d89;
              font-weight: 500;
            }
          }
        }
        &:hover {
          span {
            // font-weight: bold;
            color: #ff2d89;
          }
        }
      }
      span {
        display: block;
        &.active {
          background: rgba(255, 45, 137, 0.1);
          border-radius: 0 100px 100px 0;
          color: #ff2d89;
        }
      }
    }
  }
  .join-now {
    position: fixed;
    // left: 50%;
    width: 310px;
    // transform: translateX(-610px);
    bottom: 10px;
    a {
      display: block;
      background: #ff2d89;
      border-radius: 4px;
      font-size: 20px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 50px;
      text-align: center;
      i {
        font-size: 24px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
      }
    }
  }
  .container {
    width: 1220px;
  }
}
.m-nav {
  display: block;
}
@media screen and (max-width: 780px) {
  .m-nav {
    display: none;
  }
  .developers {
    padding: 0;
    #cam-kit-workflow{
      .exhibition-img{
        min-height: auto;
      }
    }
    .container {
      width: 100%;
    }
    .main {
      width: 100%;
      margin-left: 0;
      padding-bottom: 20px;
    }
    .nav-menu {
      display: none;
    }
    .join-now {
      position: inherit;
      bottom: auto;
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
    }
    .dev-home {
      .welcome {
        margin: 10px;
        padding: 10px;
        background: #fff;
      }
      .txt {
        padding: 20px;
        margin-top: 0;
      }
      .box {
        padding: 20px;
        margin-top: 20px;
      }
      .dev-home-inline {
        .cam-site {
          padding: 10px;
          .site-list .site-item {
            margin: 1%;
            width: 48%;
          }
        }
        .standard-model {
          width: 100%;
          height: auto;
          background: url("../../assets/img/dev/pc_img.png") no-repeat center
            70px;
          background-size: 100% auto;
          &.model2 {
            background: url("../../assets/img/dev/pc_img.png") no-repeat center 70px;
            background-size: 100% auto;
            .model-list {
              padding: 110px 60px 0 60px;
            }
          }
          .title {
            margin-bottom: 20px;
          }
          .model-list {
            padding: 110px 60px 0 60px;
          }
        }
      }
      .exhibition-img {
        width: 100% !important;
      }
      .table-box {
        width: 100%;
        overflow-x: auto;
        .table {
          width: 100%;
        }
      }
    }
  }
}
</style>
